import * as React from 'react';
import { cn } from '../lib/utils';

export interface FieldRowProps {
  testId: string;
  label: string;
  children: React.ReactNode;
  className?: string;
}

export function FieldRow({ testId, label, children, className }: FieldRowProps) {
  return (
    <div className={cn('flex items-start py-2 gap-3', className)} data-testid={testId}>
      <span className="text-[12px] text-muted-foreground w-36 shrink-0 leading-5">{label}</span>
      <span className="text-[13px] text-foreground flex-1 min-w-0 leading-5">{children}</span>
    </div>
  );
}
